import React from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import '../../../styles/admin/AdminLayout.css';

const AdminLayout = ({ children, title, onLogout, withSidebar = true }) => {
  return (
    <div className="admin-layout-container">
      {withSidebar && <AdminSidebar />}
      <div className={`admin-main-content ${!withSidebar ? 'admin-main-content--full' : ''}`}>
        <AdminHeader title={title} onLogout={onLogout} />
        <main className="admin-content-body">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;

